import styled from '@emotion/styled';
import { Container, GridItem } from 'components/Layout';
import { Text } from 'components/Typography';
import { GrayBackdrop, Loader } from 'components/Loader';
import {
    InputContainer,
    MainInputContainer,
    Header,
} from 'components/PageLayout';
import { Company } from './form';
import { useDataAccessProfiles } from 'pages/hooks';

interface Props {
    company: Company
}

export function CompanyDataAccessProfiles({ company }: Props) {
    const { dataAccessProfiles, isDataAccessProfilesLoading } =
        useDataAccessProfiles({
            companyId: company?.id,
            enabled: true,
        });
    const isBusy = isDataAccessProfilesLoading;

    return (
        <MainInputContainer direction="column">
            <GrayBackdrop open={isBusy}>
                <Loader />
            </GrayBackdrop>
            <InputContainer direction="column">
                <Header>Added Data Access Profiles</Header>
                {dataAccessProfiles?.length > 0 ? dataAccessProfiles.map((p, key) => (
                    <AddedAcountProfile direction="row" alignItems="center" key={key}>
                        <GridItem md={4} sm={4} xs={2}>
                            <StyledText noWrap fontSize="m">
                                {p.name}
                            </StyledText>
                        </GridItem>
                        <GridItem md={8} sm={8} xs={10}>
                            <Container direction="row" justify='flex-end' alignItems='center' wrap="wrap">
                                <GridItem lg={2} md={3} sm={3} xs={3}>
                                    <StyledText noWrap fontSize="m">
                                        {p.userCount} users
                                    </StyledText>
                                </GridItem>
                                <GridItem lg={3} md={3} sm={3} xs={3} wrap="wrap">
                                    <StyledText noWrap fontSize="m">
                                        {p.wpIdMask}
                                    </StyledText>
                                </GridItem>
                            </Container>
                        </GridItem>
                    </AddedAcountProfile>
                )) : (
                    <AddedAcountProfile direction="row" alignItems="center">
                        <GridItem md={4} sm={4} xs={2}>
                            <StyledText noWrap fontSize="m">
                                No Data Access Profiles added
                            </StyledText>
                        </GridItem>
                    </AddedAcountProfile>
                )}
            </InputContainer>
        </MainInputContainer>
    );



}

const AddedAcountProfile = styled(Container)`
  min-height: 40px;
  border: ${({ theme }) => `1px solid ${theme.palette.secondary.main}`};
  box-shadow: ${({ theme }) => theme.shadow.s};
  border-radius: ${({ theme }) => theme.border.radius};
  padding-left: 12px;
  margin-bottom: ${({ theme }) => theme.margin.s};
`;

const StyledText = styled(Text)`
  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xsm}px`}) {
    font-size: 10px;
  }
`;
